import { createI18n } from 'vue-i18n'
// `moment` is aliased to moment-with-locales in vite.config.ts, so all locales
// are already registered on this instance and moment.locale() below works.
import moment from 'moment'

// Import all locale files
import en from './lang/en.json'
import fr from './lang/fr.json'
import de from './lang/de.json'
import es from './lang/es.json'
import it from './lang/it.json'
import nl from './lang/nl.json'
import pt from './lang/pt.json'
import cs from './lang/cs.json'
import ja from './lang/ja.json'

let locale = navigator.language.substring(0, 2)
moment.locale(locale)

function loadLocaleMessages() {
  const messages = {
    en,
    fr,
    de,
    es,
    it,
    nl,
    pt,
    cs,
    ja,
  }
  return messages
}

export default createI18n({
  legacy: false,
  fallbackLocale: 'en',
  locale: locale,
  messages: loadLocaleMessages(),
  silentTranslationWarn: import.meta.env.PROD,
})
